import React, { useState } from 'react';
import { Link } from "react-router-dom";

import CountryFlagAndName from '../../components/countryFlagAndName.js'
import DomainLinkingIPs from '../../components/domainLinkingIPs.js'
import DomainTable from '../../components/domainTable.js'
import GeoDistribution from '../../components/geoDistribution.js'
import SectionHeader from '../../components/sectionHeader.js'
import WebsiteSecondaryPageTitle from '../../components/websiteSecondaryPageTitle.js'
import useGoogleCharts from '../../components/useGoogleCharts.js';

import {
	_printNumber, 
    _printDomainRank,
    _countryNameFromCode
	} from '../../helpers/helpers'

import {BacklinksPageResult} from '../../../../server/routes/website.js'

interface WebsiteBacklinksPageProps {
    server: string,
    pageData: unknown
}

export default function WebsiteBacklinks({ server, pageData }: WebsiteBacklinksPageProps) {

	let [data, setData] = useState(pageData as BacklinksPageResult);
	const google = useGoogleCharts();

    return (<>
        <WebsiteSecondaryPageTitle domainPageHeader={data.DomainPageHeader}/>
        <section className="section section-sm">
            <div className="container">
                <WebsiteBacklinkProfile props={data}/>
                <DomainTable domainList={data.TopLinkingDomains}/>
                <DomainLinkingIPs ipAddresses={data.IPAddresses}/>
                <GeoDistribution link={data.CanonicalURL} geoData={data.LinkingDomainGeoData} google={google}/>
            </div>
        </section>
    </>)
}

function WebsiteBacklinkProfile({ props }: { props: BacklinksPageResult }) {
    return (<>

        <div className="row row-50">
            <div className="col-12">
                <SectionHeader header={props.BacklinksProfileHeader} />
                <div className="table-outer table-responsive-lg">
                    <table className="table-custom table-custom-striped table-custom-primary">
                        <thead>
                            <tr>
                                <th style={{ width: '40%' }}></th>
                                <th style={{ width: '60%' }}></th>
                            </tr>
                        </thead>                                
                        <tbody>
                            {
                                props.DomainBacklinkInfo.LinkingRootDomainCount ?
                                <tr>
                                    <td>Total linking domains</td>
                                    <td>
                                        <b>
                                            {_printNumber(props.DomainBacklinkInfo.LinkingRootDomainCount)}
                                        </b>
                                    </td>
                                </tr>:
                                <>
                                    No backlinks found for this domain
                                </>
                            }
                            {
                                props.DomainBacklinkInfo.LinkingIPAddressCount &&
                                <tr>
                                    <td>Total linking IP addresses</td>
                                    <td>
                                        <b>
                                            {_printNumber(props.DomainBacklinkInfo.LinkingIPAddressCount)}
                                        </b>
                                    </td>
                                </tr>
                            }                                    
                            {
                                props.DomainBacklinkInfo.HighestRankingDomain &&
                                <tr>
                                    <td>Top ranking linking domain</td>
                                    <td>
                                        <Link 
                                            to={`/website/${props.DomainBacklinkInfo.HighestRankingDomain.Domain}`}
                                            className="link-hover" 
                                            title={`${props.DomainBacklinkInfo.HighestRankingDomain.Domain} technology stack and statistics`} 
                                        >
                                            <b>
                                                {props.DomainBacklinkInfo.HighestRankingDomain.Domain}
                                            </b>
                                        </Link>
                                        &nbsp;
                                        (Rank: {_printDomainRank(props.DomainBacklinkInfo.HighestRankingDomain.Rank)})
                                    </td>
                                </tr>
                            }
                            {
                                props.DomainBacklinkInfo.MostLinkedFromCountry &&
                                <tr>
                                    <td>A country with the most referring domains</td>
                                    <td>
                                        <CountryFlagAndName countryCode={props.DomainBacklinkInfo.MostLinkedFromCountry} />
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>       
    </>)
}
